import React, { useState, useEffect } from "react";
import { Drawer, Form, Icon, notification, InputNumber } from "antd";
import axios from "axios";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const DrawerQuantitativosFaltas = ({ visible, inscricaoId, onClose, form }) => {
    const [disciplinas, setDisciplinas] = useState([]);
    const [iconLoading, setIconLoading] = useState(false);

    const { getFieldDecorator } = form;

    const handleChangeQuantitativo = (quantitativo, index) => {
        var _disciplinas = disciplinas;

        _disciplinas[index].quantitativo = quantitativo;

        setDisciplinas([..._disciplinas]);
    };

    const carregarDisciplinas = () => {
        var item = new FormData();
        item.append("inscricaoId", inscricaoId);

        axios({
            method: "post",
            url: "/api/gestao-turma-matriculas/disciplinas-quantitativo",
            data: item
        })
            .then(response => {
                setDisciplinas(response.data);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data);
            });
    };

    const guardar = () => {
        form.validateFieldsAndScroll((err, values) => {
            if (err) return null;
        });

        setIconLoading(true);

        var item = new FormData();
        item.append("quantitativos", JSON.stringify(disciplinas));

        axios({
            method: "post",
            url: "/api/gestao-turma-matriculas/guardar-quantitativos",
            data: item
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Quantitativo de faltas guardado!");
                onClose();
                setIconLoading(false);
            })
            .catch(() => {
                setIconLoading(false);
                openNotificationWithIcon("error", "Erro", "Não foi possível guardar o quantitativo de faltas");
            });
    };

    const afterVisibleChange = visible => {
        if (visible) {
            form.resetFields();

            carregarDisciplinas();
        } else {
            setDisciplinas([]);
        }
    };

    return (
        <>
            <Drawer
                className="drawer-inscrever"
                width={720}
                onClose={onClose}
                visible={visible}
                style={{
                    overflow: "auto",
                    height: "calc(100% - 108px)",
                    paddingBottom: "108px"
                }}
                maskClosable={false}
                afterVisibleChange={afterVisibleChange}
            >
                <div className="bloco-drawer-associar">
                    <Form className="form-emitir-declaracao">
                        <h3 className="titulo-separador">Quantitativos por disciplina</h3>
                        <p>Indique o número de faltas registadas em cada disciplina.</p>
                        {disciplinas.map((disciplina, index) => (
                            <Form.Item label={disciplina.nome} className="quantitativo">
                                {getFieldDecorator(`quantitativo${index}`, {
                                    initialValue: disciplina.quantitativo
                                })(<InputNumber min={0} onChange={value => handleChangeQuantitativo(value, index)} />)}
                            </Form.Item>
                        ))}
                    </Form>
                </div>
                <div className="ant-drawer-footer">
                    <button className="botao-secundario" onClick={onClose} style={{ marginRight: 20, display: "inline-block" }}>
                        Voltar
                    </button>
                    <button className="botao-principal" type="primary" disabled={iconLoading} onClick={guardar}>
                        {iconLoading ? <Icon type="loading" /> : null}
                        Salvar
                    </button>
                </div>
            </Drawer>
        </>
    );
};

const FormDrawerQuantitativosFaltas = Form.create({ name: "drawer-transferencia-lista-disciplinas" })(DrawerQuantitativosFaltas);

export default FormDrawerQuantitativosFaltas;
